/**
 * Indica si un rango de fechas (YYYY-MM-DD) es consultable.
 *
 * Al teclear una fecha en un <input type="date">, el navegador emite un cambio por cada tecla
 * con fechas "válidas" pero absurdas (año 0002, 0020, 0202… hasta 2026). Consultar esos rangos
 * pide TODO el historial al servidor. Tampoco se consulta un rango invertido (inicio > fin).
 */
export function rangoFechasValido(inicio, fin) {
  const formato = /^\d{4}-\d{2}-\d{2}$/;
  if (!formato.test(String(inicio)) || !formato.test(String(fin))) return false;
  if (Number(String(inicio).slice(0, 4)) < 2000 || Number(String(fin).slice(0, 4)) < 2000) return false;
  return String(inicio) <= String(fin);
}

// Tiempo de calma (ms) tras el último cambio de fecha antes de consultar al servidor.
export const ESPERA_CAMBIO_FECHA_MS = 400;
